export default "__VITE_ASSET__Cswek7xh__"